import { createSlice } from '@reduxjs/toolkit';
import {
  bootstrapCurrentUser,
  bootstrapSettingsDetails,
  fetchCurrentUser,
  bootstrapCurrentPermission,
  bootstrapExtensionCheck,
  fetchPendingImport,
  fetchImportById,
} from './actions';
import moment from 'moment-timezone';
const initialState = {
  isLoading: null, // `null` indicates loading hasn't been attempted yet
  currUser: null,
  user: null, // this is a hack for contact import. will be fixed post alpha.
  errors: [],
  settings: null,
  isPermissionLoading: false,
  extensionInstalled: false,
  error: false,
  permissions: {},
  contactImport: null,
  contactImportById: null,
  importInitiated: false,
};

const { reducer, actions } = createSlice({
  name: 'bootstrap',
  initialState,

  reducers: {
    applyExtensionCheck: (state, { payload }) => {
      const { extensionFlag } = payload;
      state.extensionInstalled = extensionFlag;
    },
  },

  extraReducers: {
    [bootstrapCurrentUser.pending]: (state, { payload }) => {
      if (payload?.isBackground) return;
      state.isLoading = true;
    },

    [bootstrapCurrentUser.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      if (payload?.errors?.length) {
        state.errors = payload?.errors;
        state.isLoading = false;
        return;
      }

      if (payload?.response?.status) {
        state.errors = ['internal_server_error'];
        state.isLoading = false;
        return;
      }

      state.errors = [];
      // if time_zone is not set, set it to the current timezone
      if (!payload?.data?.time_zone) {
        payload.data.time_zone = moment.tz.guess();
      }
      state.currUser = payload?.data;
      state.user = payload?.data;
      state.error = false;
    },

    [bootstrapCurrentUser.rejected]: (state) => {
      state.error = false;
      state.currUser = {};
    },

    [bootstrapSettingsDetails.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      if (payload?.errors?.length) {
        state.errors = payload?.errors;
        state.isLoading = false;
        return;
      }

      if (payload?.response?.status) {
        state.errors = ['internal_server_error'];
        state.isLoading = false;
        return;
      }

      state.errors = [];
      state.settings = payload?.data;
      state.error = false;
    },

    [bootstrapSettingsDetails.rejected]: (state) => {
      state.error = false;
      state.settings = null;
    },

    [fetchCurrentUser.fulfilled]: (state, { payload }) => {
      state.user = payload?.data;
    },

    [bootstrapCurrentPermission.pending]: (state) => {
      state.permissionLoading = true; // Start loading when the request is pending
    },

    [bootstrapCurrentPermission.fulfilled]: (state, { payload }) => {
      state.permissionLoading = false; // Stop loading when the request is fulfilled
      state.permissions = payload;
    },

    [bootstrapCurrentPermission.rejected]: (state) => {
      state.permissionLoading = false; // Stop loading if the request is rejected
    },

    [bootstrapExtensionCheck.fulfilled]: (state, { payload }) => {
      state.extensionInstalled = payload;
    },

    [fetchPendingImport.fulfilled]: (state, { payload }) => {
      state.contactImport = payload;
    },

    [fetchImportById.fulfilled]: (state, { payload }) => {
      state.contactImportById = payload;
    },
  },
});

export const { applyExtensionCheck } = actions;

export default reducer;
